<template>
    <div class="flex min-h-screen items-center justify-center bg-default">
        <RouterView />
    </div>
</template>

<script lang="ts" setup>
    import { RouterView } from 'vue-router'
</script>
